import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notification_container = _resolveComponent("notification-container")!
  const _component_modals_container = _resolveComponent("modals-container")!
  const _component_http_loader = _resolveComponent("http-loader")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_notification_container),
    _createVNode(_component_modals_container),
    _createVNode(_component_http_loader)
  ], 64))
}